import { Label } from "@/components/shadcn/label";

interface Props {
  text: string
  children?: React.ReactNode;
}

export function FilterTopText({ text, children }: Props) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label className="text-xs text-muted-foreground">{text}</Label>
      {children}
    </div>
  );
}